// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bho_j bho_i bho_bc bho_r bho_st","QualityCheckboxes__quality":"ex_b"};